import React from "react"
import { getColors, MobergTheme } from "../../../../../../../Moberg"

export type VisualizationPlaceholderProps = {
    color: string
}

export const VisualizationPlaceholder = (props: VisualizationPlaceholderProps) => {
    return (
        <div style={{ height: "100%", width: "100%", borderRadius: "3px", background: props.color ?? getColors(MobergTheme.GRAY).main, display: "flex", alignItems: "center", justifyContent: "center" }}> </div>
    )
}